module.exports = __webpack_public_path__ + "img/2.a550c29b.png";